import APStatistic from './APStatistic';

export {
  APStatistic
}

export default APStatistic;
